export const SET_AGREEMENTS_DETAILS = 'agreements/SET_AGREEMENTS_DETAILS';
export const SET_MASTER_DATA = 'agreements/SET_MASTER_DATA';
